import { Table } from 'react-bootstrap';

function ReviewSubmitForm({ form }) {
  return (
    <div>
      <h6>Request Info</h6>
      <ul>
        <li><strong>Required By:</strong> {new Date(form.required_by_date).toLocaleDateString('en-IN', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                            })}
        </li>
        <li><strong>Reason:</strong> {form.reason}</li>
        <li><strong>Priority:</strong> {form.priority}</li>
        <li><strong>Notes:</strong> {form.notes || '-'}</li>
      </ul>

      <h6 className="mt-4">Items</h6>
      <Table striped bordered size="sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Product</th>
            <th>Quality</th>
            <th>Approx Quantity</th>
          </tr>
        </thead>
        <tbody>
          {form.items.map((item, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{item.product?.label || item.product || '-'}</td>
              <td>{item.quality || '-'}</td>
              <td>
                {item.approx_quantity} {item.quantity_unit}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

// No validation needed here
ReviewSubmitForm.validate = () => true;

export default ReviewSubmitForm;
